
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class JpmSecClassResultDialog extends SiteEntityDialog<JpmSecClassResultRow, any> {
        protected getFormKey() { return JpmSecClassResultForm.formKey; }
        protected getIdProperty() { return JpmSecClassResultRow.idProperty; }
        protected getLocalTextPrefix() { return JpmSecClassResultRow.localTextPrefix; }
        protected getNameProperty() { return JpmSecClassResultRow.nameProperty; }
        protected getService() { return JpmSecClassResultService.baseUrl; }


        protected form = new JpmSecClassResultForm(this.idPrefix);

    }
}